import React from 'react'

export default function ProjectAttributes({ project }) {
	if (!project || !project.data) {
		return null
	}
	const { project_name, architect, location } = project.data
	const parts = [location, architect ? `Partner: ${architect}` : null].filter(Boolean)

	return (
		<>
			<h5>{project_name}</h5>
			<p className="mt-2 hidden lg:block">{parts.join(' | ')}</p>
		</>
	)
}
